import { enqueueSnackbar } from 'notistack'; // Assuming you are using notistack for Snackbar management

export const showToast = (message: { level: 'info' | 'success' | 'warning' | 'error'; text: string }) => {
  enqueueSnackbar(message.text, { variant: message.level });
};
